import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Container,
  Menu,
} from 'semantic-ui-react';
import { flashSuccessMessage, flashErrorMessage } from '../../../actions/flash';
import NavBar from '../../../components/NavBar';
import Form from '../Units/Form';

export default class EditUnit extends Component {
  static propTypes = {
    token: PropTypes.string,
    id: PropTypes.string,
    unitID: PropTypes.string,
    loading: PropTypes.bool,
    data: PropTypes.shape({
      reference: PropTypes.string,
    }),
    onCheck: PropTypes.func,
  }
  static contextTypes = {
    store: PropTypes.object,
  }
  constructor(props) {
    super(props);
    this.state = {
      hasChanges: false,
    };
  }
  async submit(validations, unit) {
    const { store } = this.context;
    const errors = validations.filter(v => !v.isValid);
    if (errors.length > 0) {
      store.dispatch(flashErrorMessage({ header: 'Please fix form errors', list: errors.map(l => l.message) }));
      return;
    }
    let res;
    try {
      res = await this.form.submit(`/projects/${this.props.id}/units/${this.props.unitID}/`, {
        credentials: 'include',
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.token,
        },
        body: JSON.stringify(unit),
      });
    } catch (err) {
      if (err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      store.dispatch(flashErrorMessage(err));
      return;
    }
    this.setState({ hasChanges: false }, () => {
      this.handleOnCheck(false);
    });
    store.dispatch(flashSuccessMessage({ header: 'Update Success', message: `${res.reference} successfully updated` }));
  }
  handleSubmit = (event) => {
    this.form.handleSubmit(event);
  }
  handleOnChange = (hasChanges) => {
    if (hasChanges !== this.state.hasChanges) {
      this.setState({ hasChanges }, () => {
        this.handleOnCheck(hasChanges);
      });
    }
  }
  handleOnCheck = (hasChanges = false) => {
    if (this.props.onCheck) {
      this.props.onCheck(hasChanges);
    }
  }
  render() {
    return (
      <Container>
        <NavBar
          header={`Edit ${this.props.data ? this.props.data.reference : 'unit'}`}
          rightNav={
            <Menu.Item fitted>
              <Button
                positive
                content="Save"
                onClick={this.handleSubmit}
              />
            </Menu.Item>
          }
        />
        <Form
          id={this.props.id}
          ref={(ref) => { this.form = ref; }}
          onSubmit={(validations, unit) => {
            this.submit(validations, unit);
          }}
          onChange={this.handleOnChange}
          loading={this.props.loading}
          unit={this.props.data}
        />
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Project/Unit/Edit.jsx